import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { TitleTooltipProps, TooltipPosition } from "./TitleTooltip.types";
import { Container, TooltipWrapper } from "./TitleTooltip.styles";

const TitleTooltip: React.FC<TitleTooltipProps> = ({ text, maxLength = 3, children }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const [tooltipPosition, setTooltipPosition] = useState<TooltipPosition>({ top: 0, left: 0 });

  useOnClickOutside(tooltipRef, () => setIsTooltipVisible(false));

  const shouldRenderTooltip = text.length > maxLength;

  useEffect(() => {
    if (shouldRenderTooltip && containerRef.current && tooltipRef.current && isTooltipVisible) {
      const rect = containerRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.top - tooltipRef.current.offsetHeight - 4,
        left: rect.right - tooltipRef.current.offsetWidth + 329,
      });
    }
  }, [isTooltipVisible, shouldRenderTooltip]);

  const handleFocus = () => {
    if (shouldRenderTooltip) {
      setIsTooltipVisible(true);
    }
  };

  const handleBlur = () => {
    if (shouldRenderTooltip) {
      setIsTooltipVisible(false);
    }
  };

  const renderTextWithLinks = (inputText: string) => {
    const urlRegex = /(\bhttps?:\/\/[^\s]+)/g;
    const parts = inputText.split(urlRegex);
    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <Container ref={containerRef} onFocus={handleFocus} onBlur={handleBlur}>
      {children}
      {shouldRenderTooltip && isTooltipVisible &&
        ReactDOM.createPortal(
          <TooltipWrapper
            ref={tooltipRef}
            top={tooltipPosition.top}
            left={tooltipPosition.left}
            onMouseDown={(e) => e.preventDefault()}
          >
            {renderTextWithLinks(text)}
          </TooltipWrapper>,
          document.body
        )}
    </Container>
  );
};

export default TitleTooltip;
